const Kappa = require('../../assets/imgs/kappa.png');

export default { Kappa };
